// @flow
import * as React from "react";
import styled from "styled-components";
import ReactPaginate from "react-paginate";

import { isAndroidCloaca } from "./utils";
import Gettext from "./common/Gettext";
import SupportLink from "./common/SupportLink";
import { fontSize, rtl } from "./common/styled-mixins";

import Select from "./HistoryPages/Select";

const Container = styled.div`
  direction: ${({ theme }) => theme.direction};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 960px) {
    > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 30%;
    }
  }

  @media (max-width: 959px) {
    justify-content: center;
  }

  @media (max-width: 425px) {
    flex-wrap: wrap;
  }
`;

const Break = styled.span`
  color: #a7a7a7;
  font-weight: 400;
  cursor: default;
`;

const PaginationContainer = styled.div`
  ${rtl("margin-left", "auto")};

  @media (min-width: 960px) {
    flex-basis: 40%;
  }

  @media (max-width: 425px) {
    margin-left: 0;
  }

  ul {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .break {
    pointer-events: none;
    user-select: none;
    cursor: default !important;
  }

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 14px;
    color: #a7a7a7;
    border: 3px solid transparent;
    cursor: pointer;
    user-select: none;
  }

  li:hover {
    font-weight: 700;
  color: ${({theme}) => theme.tablePaginationHover || "#252525"};
  }

  li.active {
    font-weight: 700;
    color: #717171;
    border-color: #efefef;
    cursor: default;
  }

  li > a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  li > a:focus {
    outline: none;
  }

  li.previous,
  li.next {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    color: #717171;
    user-select: none;
  }

  li.previous:hover,
  li.next:hover {
    background-color: #efefef;
  }

  li.next {
    transform: rotate(180deg);
  }

  li.previous.disabled,
  li.next.disabled {
    opacity: 0.5;
    cursor: default !important;
    color: #717171 !important;
    background-color: transparent;
  }
`;

const SelectText = styled.div`
  ${rtl("margin-right", "25px")}
  font-size: ${fontSize(14)};
  color: #717171;
`;

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > div:last-of-type {
    min-width: 79px;
  }

  @media (max-width: 959px) {
    display: none;
  }
`;

const PaginationArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 6.167 10"
    fill="currentColor"
    width="6.167"
    height="10"
  >
    <path
      d="M87.767,180.867,86.6,179.7l-5,5,5,5,1.167-1.167L83.933,184.7Z"
      transform="translate(-81.599 -179.7)"
    />
  </svg>
);

type Props = {
  page: number,
  pageSize: number,
  pages: null | number,
  onPageChange: (page: { selected: number }) => void,
  onPageSizeChange: (pageSize: number) => void,
  pageSizeOptions?: Array<number>,
  paginateProps?: { [key: string]: mixed }
};

function pageSizeOptionsReducer(options: Array<number>) {
  return options.reduce((acc, option) => {
    acc.push({ label: option, value: option });
    return acc;
  }, []);
}

const Pagination = ({ pageSizeOptions = [5, 10, 15, 30], ...props }: Props) => (
  <Container>
    <SelectContainer>
      <SelectText>
        <Gettext>Rows per page</Gettext>:
      </SelectText>
      <Select
        name="news-page-rows-select"
        options={pageSizeOptionsReducer(pageSizeOptions)}
        value={{ value: props.pageSize, label: props.pageSize }}
        onChange={e => props.onPageSizeChange(Number(e.value))}
      />
    </SelectContainer>

    {props.pages != null &&
      props.pages > 1 && (
        <PaginationContainer style={isAndroidCloaca ? { marginLeft: "unset"} : null}>
          <ReactPaginate
            initialPage={props.page}
            forcePage={props.page}
            previousLabel={<PaginationArrow />}
            nextLabel={<PaginationArrow />}
            breakLabel={<Break>...</Break>}
            breakClass="break"
            pageCount={Number(props.pages)}
            marginPagesDisplayed={1}
            pageRangeDisplayed={5}
            onPageChange={props.onPageChange}
            activeClassName="active"
            {...props.paginateProps}
          />
        </PaginationContainer>
      )}

    {!isAndroidCloaca && <div>
      <SupportLink target="_blank" />
    </div>}
  </Container>
);

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination.js